import { useEffect, useState } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { Card, Spin, Result, Button } from 'antd';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';
import paths from 'assets/routes/paths';
import { SOLICITUD_TIPOS } from 'assets/data/SolicitudesEstados';
import InicioMantencionConfirm from 'components/mantenciones/InicioMantencionConfirm';

// Decisión pura por estado (testeable sin red).
export const decidirDestino = (solicitud) => {
  if (!solicitud || !solicitud.status) return { tipo: 'no-disponible' };
  const { status, id_mantencion } = solicitud;
  if (status === SOLICITUD_TIPOS.ASIGNADA) return { tipo: 'confirmar' };
  if (
    status === SOLICITUD_TIPOS.EN_CURSO ||
    status === SOLICITUD_TIPOS.ENVIADA ||
    status === SOLICITUD_TIPOS.FINALIZADA
  ) {
    return { tipo: 'redirect', to: paths.specialist.mantenciones.detail(id_mantencion) };
  }
  return { tipo: 'no-disponible' };
};

const IniciarSolicitudPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState({ loading: true, solicitud: null, error: false });

  useEffect(() => {
    let cancelado = false;
    const token = getAccessTokenApi();
    axios
      .get(`${API_PATH}/solicitudes/${id}`, { headers: { Authorization: token } })
      .then(({ data }) => {
        if (!cancelado) setEstado({ loading: false, solicitud: data, error: false });
      })
      .catch(() => {
        if (!cancelado) setEstado({ loading: false, solicitud: null, error: true });
      });
    return () => {
      cancelado = true;
    };
  }, [id]);

  if (estado.loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  const destino = decidirDestino(estado.solicitud);

  if (destino.tipo === 'redirect') {
    return <Navigate to={destino.to} replace />;
  }

  if (destino.tipo === 'no-disponible') {
    return (
      <Result
        status="warning"
        title="Solicitud no disponible"
        subTitle="Esta solicitud no existe o no puede iniciarse."
        extra={
          <Button type="primary" onClick={() => navigate(paths.specialist.root)}>
            Ir al inicio
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: 16 }}>
      <Card title="Iniciar mantención">
        <InicioMantencionConfirm
          solicitud={estado.solicitud}
          onCancel={() => navigate(paths.specialist.root)}
        />
      </Card>
    </div>
  );
};

export default IniciarSolicitudPage;
